import React from 'react'
import './Spinner.css'

const Spinner = () => {
  return (
    <div className="spinner_c">
    <div className="spinner"></div>;
  </div>
  )
}

export default Spinner